import { useQuery } from "@tanstack/react-query";

import { getScimTokenById, getScimTokens } from "../../services";

export const useGetScimTokens = (column, direction) => {
	return useQuery({
		queryKey: ["scim_token", column, direction],
		queryFn: () => getScimTokens(column, direction),
		meta: {
			errorMessage: "There was an error getting the scim tokens.",
		},
	});
};

export const useGetScimTokenById = (id: string) => {
	return useQuery({
		queryKey: ["scim_token", id],
		queryFn: () => getScimTokenById(id),
		meta: {
			errorMessage: "There was an error getting the scim token.",
		},
	});
};
